import DashboardComponent from "./Dashboard.container";

export default DashboardComponent;
